__turbopack_context__.v({
  "count": "StackedProfilePicture-module__3Ro2IG__count",
  "medium": "StackedProfilePicture-module__3Ro2IG__medium",
  "picture": "StackedProfilePicture-module__3Ro2IG__picture",
  "pictures": "StackedProfilePicture-module__3Ro2IG__pictures",
  "small": "StackedProfilePicture-module__3Ro2IG__small",
});
